import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-navy-light py-20 md:py-28 relative" data-id="element-33">
      {/* Gold Border Accent */}
      <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-34" />
      <div className="absolute inset-x-0 bottom-0 h-1 bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-35" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-37">
          {/* Guarantee Seal */}
          <motion.div initial={{
          scale: 0,
          rotate: -180
        }} whileInView={{
          scale: 1,
          rotate: 0
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          damping: 15,
          delay: 0.2
        }} className="inline-block mb-8" data-id="element-38">
            <div className="relative w-40 h-40 md:w-48 md:h-48" data-id="element-39">
              {/* Outer Ring */}
              <div className="absolute inset-0 rounded-full border-4 border-gold" data-id="element-40" />
              {/* Inner Ring */}
              <div className="absolute inset-2 rounded-full border-2 border-gold/50" data-id="element-41" />
              {/* Center Content */}
              <div className="absolute inset-4 rounded-full bg-gold flex flex-col items-center justify-center p-4" data-id="element-42">
                <ShieldCheckIcon className="w-8 h-8 text-navy mb-1" data-id="element-43" />
                <p className="font-heading text-navy text-xs md:text-sm font-bold text-center leading-tight" data-id="element-44">
                  2X ROI
                  <br data-id="element-45" />
                  or We Work
                  <br data-id="element-46" />
                  For Free
                </p>
                <p className="text-navy/70 text-[10px] mt-1 font-semibold" data-id="element-47">
                  GUARANTEE
                </p>
              </div>
            </div>
          </motion.div>

          {/* Headline */}
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-48">
            You Are Protected By Our{' '}
            <span className="text-gold" data-id="element-49">"Double Your Investment"</span>{' '}
            Guarantee
          </h2>

          {/* Guarantee Text */}
          <div className="bg-navy rounded-xl p-6 md:p-8 border border-gold/30" data-id="element-50">
            <p className="text-white text-lg md:text-xl leading-relaxed" data-id="element-51">
              We guarantee that The Automatic Paralegal Assistant will generate
              at least a{' '}
              <span className="text-gold font-bold" data-id="element-52">
                2X return on your investment
              </span>{' '}
              within the first 90 days, measured in a combination of recovered
              billable hours and direct operational cost savings.{' '}
              <span className="text-white font-semibold" data-id="element-53">
                If we fail to meet this benchmark, we will continue to work for
                free until we do.
              </span>
            </p>
            <p className="text-gold font-heading font-bold text-2xl mt-6" data-id="element-54">
              You cannot lose.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}